module.exports = __webpack_public_path__ + "media/30.2b39308c.mp3";